import { IVendorCompanyMast } from "../../../models/VendorCompanyMast";

export const EmptyVendorCompany: IVendorCompanyMast = {
    vendor_Company_ID: undefined,
    vendor_Company_Name: '',
    vendor_Type: 5,
    vendor_Type_Name: '',
    vendor_Company_FidNo: '',
    vendor_Company_Phone: '',
    vendor_Company_Phone1: '',
    vendor_Company_FaxNo: '',
    street_Address: '',
    city_ID: 0,
    city_Name: '',
    city: {
        city_ID: 0,
        city_Name: ''
    },
    state_ID: 0,
    state_Name: '',
    state: {
        state_ID: 0,
        state_Name: ''
    },
    website_URL: '',
    major_Technology: '',
    added_By_User: 0,
    category: 0,
    client_Category_ID: 0,
    service_Department: ""
}